module.exports = __webpack_public_path__ + "static/media/thumbnail-plaza_felujitas_1.33efa934.jpg";